import api from '@/services/Api'

export default {
    view (paimentMethodId) {
        return api().get(`/stripe/paymentsMethod/${paimentMethodId}`)
    },
}
